import { localeOrder, routeDefinitions, siteConfig, siteContent } from '../content/siteContent.js'

const legalSlugs = ['privacy', 'terms']

export function getLocalizedPath(locale, keyOrSlug = 'home') {
  const route = routeDefinitions.find((item) => item.key === keyOrSlug || item.slug === keyOrSlug)
  const slug = route ? route.slug : keyOrSlug
  return slug ? `/${locale}/${slug}` : `/${locale}/`
}

export function getLocaleFromPath(pathname = '/') {
  const path = normalizePath(pathname)
  return localeOrder.find((locale) => path === `/${locale}` || path.startsWith(`/${locale}/`)) ?? siteConfig.defaultLang ?? 'en'
}

export function getSlugFromPath(pathname = '/') {
  const path = normalizePath(pathname)
  const locale = getLocaleFromPath(path)
  const raw = path.replace(new RegExp(`^/${locale}/?`), '').replace(/^\/+|\/+$/g, '')
  return raw || 'home'
}

export function resolveRoute(pathname = '/') {
  const locale = getLocaleFromPath(pathname)
  const slug = getSlugFromPath(pathname)
  const route = routeDefinitions.find((item) => item.slug === slug || item.key === slug)
  const isLegal = legalSlugs.includes(slug)

  return {
    locale,
    slug: route?.key ?? (isLegal ? slug : 'home'),
    isKnown: Boolean(route || isLegal),
  }
}

export function createAlternates(slug = 'home') {
  return localeOrder.map((locale) => {
    const href = `${siteConfig.siteUrl}${getLocalizedPath(locale, slug)}`.replace(/\/$/, slug === 'home' ? '/' : '')
    return {
      locale,
      hrefLang: siteContent[locale].htmlLang,
      href,
    }
  })
}

export function getRouteMeta(pathname = '/') {
  const { locale, slug, isKnown } = resolveRoute(pathname)
  const safeSlug = isKnown ? slug : 'home'
  const page = siteContent[locale].pages[safeSlug] ?? siteContent[locale].pages.home
  const path = getLocalizedPath(locale, safeSlug)

  return {
    locale,
    slug: safeSlug,
    title: page.title,
    description: page.description,
    canonical: `${siteConfig.siteUrl}${path}`.replace(/\/$/, safeSlug === 'home' ? '/' : ''),
    alternates: createAlternates(safeSlug),
    ogLocale: siteContent[locale].ogLocale,
    htmlLang: siteContent[locale].htmlLang,
  }
}

export function detectPreferredLocale(language = '') {
  const lower = language.toLowerCase()
  if (lower === 'zh-tw' || lower === 'zh-hk' || lower === 'zh-mo') return 'zh-TW'
  if (lower.startsWith('zh')) return 'zh-CN'
  return 'en'
}

export function normalizePath(pathname = '/') {
  const path = pathname.split('?')[0].split('#')[0]
  return path.startsWith('/') ? path : `/${path}`
}
